module.exports = __webpack_public_path__ + "static/media/HCMM645.9700bf7f.jpg";